import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  isSuccess: false,
  message: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.INVENTORY_ASSIGN_TOOLS_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccess: false,
      };
    case actionConstants.INVENTORY_ASSIGN_TOOLS_SUCCESS:
      return {
        ...state,
        message: action.message,
        isfetching: false,
        isSuccess: true,
      };
    case actionConstants.INVENTORY_ASSIGN_TOOLS_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false,
      };
    case actionConstants.INVENTORY_ASSIGN_TOOLS_RESET:
      return { ...initialState };
    default:
      return state;
  }
};
